// "staff" accounts are screen-limited admin-side users - everywhere the app
// previously only checked for role:"admin" to decide layout/redirects/nav,
// it needs to treat "admin" and "staff" the same way. Use this instead of a
// raw `user?.role === 'admin'` check so a new call site can't be missed.
export const isAdminSide = (user) => user?.role === 'admin' || user?.role === 'staff';
